export const COMMENT_ACTION = 'Comment';
export const NAVIGATION_ITEM_CLICK = 'Tab Click';
export const PROJECT_CLICK_ACTION = 'Project Click';
export const PROJECT_SUBSCRIBE_CONTACT_CLICK_ACTION = 'Contact';
export const FREE_TEXT_SEARCH_ACTION = 'FreeText';
export const LOCATION_SEARCH_ACTION = 'Location';
export const PROJECT_SEARCH_ACTION = 'Project';
export const ARTICLE_CLICK_ACTION = 'Article Click';
export const ARTICLE_MORE_ACTION = 'More Article';
export const ARTICLE_READ_MORE_ACTION = 'Read More';
export const ARTICLE_TYPE_CHANGE_ACTION = 'Article Type Change';
export const ARTICLE_CAROUSEL_ACTION = 'Carousel Interaction';
export const ARTICLE_PAGE_NAVIGATION = 'In Page Navigation';
export const HIGHLIGHT_TOPIC_CLICK_ACTION =
  'Explore Articles By Highlight Topics';
export const PROPERTY_TYPE_CLICK_ACTION = 'Explore Article By Property Type';
export const EDITORS_PICKS_CAROUSEL_CLICK_ACTION = 'Carousel Interaction';
export const ARTICLE_FEED_TAB_CLICK_ACTION = 'Article Type Change';
export const ARTICLE_FEED_SHOW_MORE_CLICK_ACTION = 'More Article';
export const ARTICLE_SUBSCRIBE_CLICK_CONTACT_ACTION = 'Contact';
export const VIEW_ALL_ARTICLES = 'View All Articles';
export const GALLERY_NEXT_ACTION = 'Next Photo';
export const GALLERY_THUMBNAIL_ACTION = 'Photo Thumbnails Click';
export const SHOW_GDPR_POPUP_MESSAGE = 'Show GDPR Popup';
export const CLOSE_GDPR_POPUP_MESSAGE_BY_X = 'Hide GDPR Popup with X';
export const CLOSE_GDPR_POPUP_MESSAGE_BY_OK = 'Hide GDPR Popup with OK';
export const REGISTER_BUTTON_CLICK_ACTION = 'New User Registration';
export const LOGIN_BUTTON_CLICK_ACTION = 'Login Click';
export const DD_LISTING_CLICK_ACTION = 'DD Listing Click';
export const DD_LISTING_CAROUSEL_ACTION = 'DD Listing Carousel Interaction';
